import type { ThemeComponentType } from '../types';

export const Table: ThemeComponentType = {
  defaultProps: {},
  styles: theme => ({
    root: {
      '.resizer': {
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '5px',
        background: theme.colors.violet[0],
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none',
        opacity: 0,

        '&.isResizing': {
          background: theme.colors.violet[0],
          opacity: 1,
        },

        '&:hover': {
          transition: 'opacity 0.2s ease',
          background: theme.colors.violet[0],
          opacity: 1,
        },
      },

      '.resizer.ltr': {
        right: 0,
      },

      '.resizer.rtl': {
        left: 0,
      },
      background: theme.white,
      borderColor: theme.colors.gray[1],
      thead: {
        background: theme.colors.violet[1],
        tr: {
          boxShadow: `0 1px 0px ${theme.colors.gray[1]}`, // hack for sticky row and his border
          th: {
            position: 'relative',
            padding: '16px',
            fontSize: theme.fontSizes.md,
            fontWeight: 500,
            color: theme.colors.violet[9],
            borderColor: theme.colors.gray[1],
          },
        },
        '&.sticky': {
          position: 'sticky',
          top: '-18px',
          zIndex: 10,
        },
      },
      tbody: {
        tr: {
          td: {
            padding: '16px',
            fontSize: theme.fontSizes.md,
            fontWeight: 500,
            color: theme.colors.violet[9],
            borderColor: theme.colors.gray[1],
          },
          '&.rowClick:hover': {
            cursor: 'pointer',
            background: theme.colors.violet[1],
          },
        },
      },
      tfoot: {
        background: theme.colors.violet[1],
        border: `1px solid ${theme.colors.gray[1]}`,
        tr: {
          td: {
            padding: '16px',
            fontSize: theme.fontSizes.md,
            fontWeight: 500,
            color: theme.colors.violet[9],
            borderTop: `1px solid ${theme.colors.gray[1]}`,
          },
        },
        '&.sticky': {
          position: 'sticky',
          bottom: '-18px',
          zIndex: 10,
        },
      },
    },
  }),
};
